// extracted by mini-css-extract-plugin
export default {"root":"TruckSelect_root__cAZNc","wrapper":"TruckSelect_wrapper__rPYsU","logo":"TruckSelect_logo__inJhL"};